import type { ReactNode } from 'react';
import { getBrandAsset } from '@/themes';

/** The frame of a page opened from an emailed link, signed in or not: the brand's logo over one column. */
export function PublicLinkPage({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen bg-background">
      <header className="mx-auto max-w-2xl px-4 pt-6 sm:px-6">
        <span className="inline-block rounded-lg bg-logo-surface px-3 py-2">
          <img src={getBrandAsset('logo.svg')} alt="Logo" className="h-6" />
        </span>
      </header>
      <main className="mx-auto max-w-2xl px-4 py-10 sm:px-6 sm:py-14">{children}</main>
    </div>
  );
}

export const PUBLIC_LINK_HEADLINE =
  'text-[clamp(1.75rem,1.15rem+1.7vw,2.5rem)] font-medium leading-tight tracking-[-0.024em] text-foreground';
